// extracted by mini-css-extract-plugin
module.exports = {"deExtendedNameFields":"_9f05a04"};